import {useContext, useLayoutEffect} from 'react';

import {isNil} from 'lodash';
import {FooterContext} from 'ui/contexts/Footer';

export const {iframe} = window.YC;

const useFooter = (hasFooter?: boolean) => {
    const {setFooter} = useContext(FooterContext);
    useLayoutEffect(() => {
        if (iframe && !isNil(hasFooter) && setFooter) {
            setFooter(hasFooter);
        }
    }, [hasFooter, setFooter]);
};
export default useFooter;
